import styled from 'styled-components'

import { COLOURS } from 'resources'

import RoundedButton from 'components/RoundedButton'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;
`

export const SectionSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLOURS.neutralGrey2};
  margin-top: 10px;
`

export const SectionBoldText = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: ${COLOURS.neutralBlack};
`

export const SectionText = styled.div`
  font-size: 20px;
  color: ${COLOURS.neutralBlack};
`

export const RedemptionProcessNote = styled.div`
  font-size: 16px;
  text-align: left;
  margin-top: 15px;
`

export const RedemptionProcessNoteWarning = styled.div`
  color: ${COLOURS.secondaryRed1};
  font-weight: bold;
`

export const RedemptionProcessNoteContainer = styled.div`
  margin: 10px 0;
`

export const RedemptionSelectionButton = styled(RoundedButton).attrs({
  withArrow: true,
})`
  margin-top: 30px;
`

export const CancelButton = styled(RoundedButton).attrs({
  variant: 'transparent',
})`
  width: 100%;
  margin-top: 5px;
`
